export function groupObjectByKey (array, key) {
  return array.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

export function groupObjectByChildKey (array, child, key) {
  return array.reduce(function (rv, x) {
    (rv[x[child][key]] = rv[x[child][key]] || []).push(x)
    return rv
  }, {})
}
